module.exports = __webpack_public_path__ + "img/Pharmacist’s Role in Immunization.0c811d03.jpg";